import type { VariantProps } from 'tailwind-variants'
import { tv } from 'tailwind-variants'

import { typography } from './typography.styles'

/**
 * Canonical overlay-surface (modal/dialog/drawer) title typography (FE-707).
 * Owned here so call sites cannot restyle it — every overlay title is Poppins
 * (`font-heading`): `default` = h6 (20px) for standard modals, `lg` = h4 (32px)
 * for promo/upgrade takeovers. Shared by both Dialog and Drawer headers so the
 * two surfaces can never drift.
 */
export const overlayTitleVariants = tv({
  base: 'm-0 p-0',
  variants: {
    size: {
      default: typography.h6,
      lg: typography.h4,
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

export type OverlayTitleSize = NonNullable<VariantProps<typeof overlayTitleVariants>['size']>
